module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/cd6b5a6158a14e37dd04cd251ce7450f.png";